module.exports = __webpack_public_path__ + "static/media/Crash Test Dummy.14141765.jpg";